






























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import InfoBar from '@/components/common/InfoBar.vue';
import Menu from '@/components/common/Menu.vue';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';
import OperatingSystemSelector from '@/components/new-dedicated-machine/OperatingSystemSelector.vue';
import { newDedicatedMachineService } from '@/components/new-dedicated-machine/services/NewDedicatedMachineService';
import { OperatingSystem } from '@/interfaces/OperatingSystem';
import { pricesService } from '@/services/PricesService';
import { privateNetworkService } from '@/components/network/private-network/services/PrivateNetworkService';
import KeysConfigurationDialog from '@/components/new-dedicated-machine/KeysConfigurationDialog.vue';
import { SshKey } from '@/interfaces/SshKey';
import AddNewPrivateNetworkDialog from '@/components/network/private-network/AddNewPrivateNetworkDialog.vue';
import EventBus from '@/EventBus';
import { limitsService } from '@/services/LimitsService';

@Component({
  components: {
    Header,
    InfoBar,
    Menu,
    OperatingSystemSelector,
    PriceWithCurrency,
    KeysConfigurationDialog,
    AddNewPrivateNetworkDialog,
  },
})
export default class NewDedicatedMachine extends Vue {
  workspaceId: number = 0;
  regionId: number = 0;
  dedicatedMachineId: number = 0;
  dedicatedMachineData: any = [];
  selectedKeys: SshKey[] = [];
  os: any = {
    system: null,
    version: null,
    auth: null,
    authType: 'pass',
    keys: [],
  };
  hoursInMonth: number = 730;
  dedicatedMachinePrice: any = {};
  priceModifier: number = 0.00001;
  network: any = [];
  additionalPublicIpAddress: boolean = false;
  publicIpAddressPrice: any = {
    cents: 0,
  };
  selectedNetwork: any = [];
  privateNetworks: any = [];
  machineName: string = '';
  noDedicatedNetworks: string = '';
  isNetworkEmpty: boolean = false;
  isActiveNameValidation: boolean = false;
  isActiveNetworkValidation: boolean = false;
  isOperatingSystemSelectable: boolean = true;
  selectedAuth = '1';
  keysCount = 0;
  isModalShown: boolean = false;
  isLoadingSelectOptions: boolean = false;
  isAddNewPrivateNetworkModalShown: boolean = false;
  minUsageFundsMissing: boolean = false;
  isTrialActivated: boolean = false;
  shouldSelectNetworkId = 0;
  publicIpAddressesLimits: any = {};
  publicIpAddressesCurrentUsage: any = {};
  showPublicIpAddressesLimitInfo: boolean = false;

  @Watch('$store.state.privateNetworks.private_networks', { immediate: true, deep: true })
  onNetworksChange() {
    this.isLoadingSelectOptions = false;
    if (this.workspaceId !== 0) {
      this.getDedicatedPrivateNetworks();
    }
  }

  @Watch('selectedAuth')
  onAuthChange(val: string) {
    this.os.auth = val === '1' ? this.$t('password') : this.$t('SSHKeys');
    this.os.authType = val === '1' ? 'pass' : 'ssh';
  }

  @Watch('additionalPublicIpAddress')
  totalPricePerMonth() {
    if (this.additionalPublicIpAddress) {
      return (
        (this.dedicatedMachinePrice.cents + this.publicIpAddressPrice.cents) * this.hoursInMonth * this.priceModifier
      );
    } else {
      return this.dedicatedMachinePrice.cents * this.hoursInMonth * this.priceModifier;
    }
  }

  @Watch('additionalPublicIpAddress')
  totalPricePerHour() {
    if (this.additionalPublicIpAddress) {
      return (this.dedicatedMachinePrice.cents + this.publicIpAddressPrice.cents) * this.priceModifier;
    } else {
      return this.dedicatedMachinePrice.cents * this.priceModifier;
    }
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.dedicatedMachineId = parseInt(this.$route.params.dedicatedMachineId, 10);
    this.os.auth = this.$t('password');
    this.getDedicatedPrivateNetworks();
    newDedicatedMachineService
      .getSelectedDedicatedMachine(this.workspaceId, this.regionId, this.dedicatedMachineId)
      .then((data: any) => {
        this.dedicatedMachineData = data;
        this.isOperatingSystemSelectable = data.os_selectable;
        pricesService.getPrices(this.workspaceId, this.regionId).then((data: any) => {
          this.dedicatedMachinePrice = data.find(
            (resource: any) => this.dedicatedMachineData.resource === resource.resource
          );
          this.publicIpAddressPrice = data.find((resource: any) => resource.resource === 'public_ip_address');
        });
      })
      .catch(() => {});
    EventBus.$on('select-private-network', (network: any) => {
      this.shouldSelectNetworkId = network.id;
    });
    this.getLimits();
  }

  getLimits() {
    limitsService.getLimits(this.workspaceId, this.regionId).then((data: any) => {
      this.publicIpAddressesLimits = parseInt(data.public_networks, 10);
      limitsService.getCurrentUsage(this.workspaceId, this.regionId).then((data: any) => {
        this.publicIpAddressesCurrentUsage = parseInt(data.public_networks, 10);
      });
    });
    if (this.publicIpAddressesLimits - this.publicIpAddressesCurrentUsage === 0) {
      this.showPublicIpAddressesLimitInfo = true;
    }
  }
  getDedicatedPrivateNetworks() {
    privateNetworkService
      .getDedicatedPrivateNetworks(this.workspaceId, this.regionId)
      .then((data: any) => {
        this.privateNetworks = data.private_networks.filter((el: any) => el.state === 'idle');
        this.selectedNetwork = this.privateNetworks.find((network: any) => network.id === this.shouldSelectNetworkId);
        this.network = this.selectedNetwork;
      })
      .catch(() => {});
  }
  rentDedicatedMachine(productId: number, operatingSystemId: number) {
    this.isActiveNameValidation = true;
    this.isActiveNetworkValidation = true;
    let auth = {
      type: 'ssh',
      ssh_keys: this.os.keys,
    };
    if (this.os.authType === '1' || this.os.authType === 'pass') {
      auth = {
        type: 'password',
        ssh_keys: [],
      };
    }
    newDedicatedMachineService
      .reserveDedicatedMachine(this.workspaceId, this.regionId, {
        name: this.machineName,
        dm_operating_system_id: this.isOperatingSystemSelectable ? operatingSystemId : null,
        dm_product_id: productId,
        dedicated_private_network_id: this.network && this.network.id ? this.network.id : null,
        authorization: auth,
        add_dedicated_public_ip: this.additionalPublicIpAddress,
      })
      .then(() => {
        this.$router
          .push(`/workspaces/${this.workspaceId}/regions/${this.regionId}/dedicated-machines-list`)
          .catch(() => {});
      })
      .catch(data => {
        if (data && data.data && data.status === 403) {
          if (data.data.error === 'min_usage_funds_missing') {
            this.minUsageFundsMissing = true;
          }
          if (data.data.error === 'trial_active') {
            this.isTrialActivated = true;
          }
        }
      });
  }
  selectOS(system: OperatingSystem) {
    this.os.system = system;
    this.os.version = system.version;
  }
  selectVersion(system: OperatingSystem) {
    this.os.system = system;
    this.os.version = system.version;
  }
  setKeys(keys: SshKey[]) {
    if (!keys) {
      this.selectedAuth = '1';
    }
    this.keysCount = keys.length;
    this.selectedKeys = keys;
    this.os.keys = keys;
  }
  onClose() {
    this.minUsageFundsMissing = false;
    this.isTrialActivated = false;
  }
}
